module.exports = __webpack_public_path__ + "img/ICO_premium.810abe7f.svg";